import Image from "@/components/AppImage";
import Link from "@/components/AppLink";
import feature_Illu_index11 from "/public/img/feature-Illu-index11.png";
import features_1_icon from "/public/img/features-1-icon.png";
import features_2_icon from "/public/img/features-2-icon.png";
import features_3_icon from "/public/img/features-3-icon.png";
import features_4_icon from "/public/img/features-4-icon.png";
import features_5_icon from "/public/img/features-5-icon.png";

const Features = () => {
  return (
    <section className="features-inner index11">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="section-header">
                <h3>Everything you need in your pocket</h3>
                <p>
                  The mobile experience mirrors desktop power—just reorganized
                  for quick taps, biometric login, and offline-friendly
                  notifications.
                </p>
              </div>
              <div className="right-area">
                <ul>
                  <li>
                    <Link className="xxlr" href="#">
                      <div className="img-area">
                        <Image src={features_1_icon} alt="image" />
                      </div>
                      Send client invoices
                    </Link>
                  </li>
                  <li>
                    <Link className="xxlr" href="#">
                      <div className="img-area">
                        <Image src={features_2_icon} alt="image" />
                      </div>
                      Approve contractor payouts
                    </Link>
                  </li>
                  <li>
                    <Link className="xxlr" href="#">
                      <div className="img-area">
                        <Image src={features_3_icon} alt="image" />
                      </div>
                      Bulk Payments
                    </Link>
                  </li>
                  <li>
                    <Link className="xxlr" href="#">
                      <div className="img-area">
                        <Image src={features_4_icon} alt="image" />
                      </div>
                      Track multi-currency wallets
                    </Link>
                  </li>
                  <li>
                    <Link className="xxlr" href="#">
                      <div className="img-area">
                        <Image src={features_5_icon} alt="image" />
                      </div>
                      Push alerts for every rail
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 d-flex justify-content-center">
              <div className="section-illu">
                <Image src={feature_Illu_index11} alt="image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
